import { useCallback, useRef } from 'react'
import { logger } from 'helpers/logger'

/**
 * Ensures an async function runs only once at a time.
 * Additional calls while it's running are ignored.
 */
function useAsyncLock<TArgs extends unknown[] = unknown[], TReturn = unknown>(
  fn: (...args: TArgs) => Promise<TReturn> | TReturn,
) {
  const lockRef = useRef(false)

  return useCallback(
    async (...args: TArgs) => {
      if (lockRef.current) {
        return
      }
      lockRef.current = true
      try {
        return await fn(...args)
      } catch (e) {
        logger.error(JSON.stringify(e))
        throw e
      } finally {
        lockRef.current = false
      }
    },
    [fn],
  )
}

export default useAsyncLock
